import MuiDialog from '@mui/material/Dialog';
import {
  type ComponentPropsWithoutRef,
  type ComponentRef,
  forwardRef,
} from 'react';

type DialogProps = ComponentPropsWithoutRef<typeof MuiDialog>;
type DialogRef = ComponentRef<typeof MuiDialog>;

const Dialog = forwardRef<DialogRef, DialogProps>((props, ref) => {
  return <MuiDialog ref={ref} {...props} />;
});
Dialog.displayName = 'Dialog';
export default Dialog;
